import React from "react";
import DataGrid, { Column, LoadPanel, Scrolling, FilterRow } from "devextreme-react/data-grid";
import { withStyles } from "@material-ui/core/styles";
import { columns } from "./utils";

const styles = {
  root: {
    display: "flex",
    flexDirection: "row",
    "& #planGridContainer": {
      height: "320px"
    }
  }
};

class SelectProgramTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      collapsed: false,
      //selectedProgramItems: [],
      focusedItem: -1,
      focusedRowIndex: -1
    };

    //this.selectedProgramItems = this.selectedProgramItems.bind(this);
    this.searchByText = this.searchByText.bind(this);
    this.onRowClick = this.onRowClick.bind(this);
    this.dataGridRef = React.createRef();
  }

  /*selectProgramItems({ selectedRowsData }) {
    this.setState({ selectedProgramItems: selectedRowsData });
  }*/

  searchByText(e) {
    const text = e.target.value;
    this.dataGridRef.current.instance.searchByText(text);
  }

  onRowClick(e) {
    const {onProgramSelected} = this.props;
    const focusedItem = e !== -1 ? e.data.id : e;
    const focusedRowIndex = e !== -1 ? e.rowIndex : e;
    this.setState({ focusedItem, focusedRowIndex });
    onProgramSelected(focusedItem);
  }

  render() {
    const {
      //selectedProgramItems,
      focusedRowIndex,
      focusedItem
    } = this.state;
    const {
      programList,
      classes
    } = this.props;
    const { root } = classes;

    return (
      <div className={root}>
        <DataGrid
          elementAttr={{
            id: "planGridContainer"
          }}
          ref={this.dataGridRef}
          wordWrapEnabled={true}
          dataSource={programList}
          //onSelectionChanged={this.selectProgramItems}
          focusedRowEnabled
          errorRowEnabled={false}
          onRowClick={this.onRowClick}
          focusedRowIndex={focusedRowIndex}
          selection={{ mode: 'single' }}
          showBorders={true}
        >
          {columns.map(column => (
            <Column key={column.dataField} {...column} />
          ))}
          <FilterRow visible={true} />
          <Scrolling mode="virtual" />
          <LoadPanel enabled/>
        </DataGrid>
      </div>
    );
  }
}

export default withStyles(styles)(SelectProgramTable);
